// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3uSrl","inputWrap":"Table_inputWrap__E9lFy","col":"Table_col__2OwB_","bmiTooltip":"Table_bmiTooltip__MB7S9"};